// ** Third Party Components
import loadable from "@loadable/component";
import { useTranslation } from "react-i18next";

// ** Custom Components
import UserMediaSkeletor from "components/user/UserMediaSkeletor";
import Block from "components/layout/Block";

const TextEditor = loadable(
	() => import("components/layout/TextEditor/TextEditor"),
	{ ssr: false }
);

const InteractiveCommentTextEditor = ({
	editor,
	isEditorVisible,
	accept,
	isAuth,
	currentLoggedUser,
	disableEditor,
	cantCommentMessage,
	linkOnButtonToPayments,
	inModal,
}) => {
	const { t } = useTranslation(["common"]);

	if (!isAuth || !isEditorVisible) {
		return null;
	}

	return (
		<Block mt={2}>
			<UserMediaSkeletor
				user={currentLoggedUser}
				size="xsmall"
				noMarginBottom
				content={
					<TextEditor
						ref={editor}
						singleLine
						button={{
							onClick: (event, text) => {
								const { plain } = editor.current.serialize();

								if (
									!plain.replace(/\u200B/g, "").trim().length
								) {
									return;
								}

								accept(text);
							},
						}}
						placeholder={t("common:placeholder.write")}
						disabled={disableEditor}
						tooltipInfo={cantCommentMessage}
						linkOnButtonToPayments={linkOnButtonToPayments}
						inModal={inModal}
					/>
				}
			/>
		</Block>
	);
};
export default InteractiveCommentTextEditor;
